export const getCorrectHEXColor = (hexColor: string) => {
  // Return black if hex color is not provided or is empty
  if (!hexColor || hexColor === '#') return '#000000'

  const cleanedValue = hexColor.replace(/[^0-9A-Fa-f]/g, '')
  let correctHEXColor = `#${cleanedValue}`

  // Example: #1 => #111111
  if (correctHEXColor.length === 2) {
    for (let i = 0; i < 5; i++) {
      correctHEXColor += correctHEXColor[1]
    }

    return correctHEXColor
  }

  // Example: #12 => #111222
  if (correctHEXColor.length === 3) {
    const c1 = correctHEXColor[1]
    const c2 = correctHEXColor[2]

    correctHEXColor = `#${c1}${c1}${c1}${c2}${c2}${c2}`

    return correctHEXColor
  }

  // Example: #123 | #1234 | #12345 => #112233
  if (correctHEXColor.length > 3 && correctHEXColor.length < 7) {
    const c1 = correctHEXColor[1]
    const c2 = correctHEXColor[2]
    const c3 = correctHEXColor[3]

    correctHEXColor = `#${c1}${c1}${c2}${c2}${c3}${c3}`
    return correctHEXColor
  }

  return correctHEXColor
}
